const styles = theme => {
  return {
    container: {
      display: 'block',
    },
    field: {
      '& .MuiOutlinedInput-root': {
        fontSize: '12px',

        background: theme.palette.primary.white,
        borderRadius: '0px !important',
        transition: `all 0.1s`,
        '& .MuiOutlinedInput-input': {
          borderRadius: '0px',
          padding: '17.5px 14px !important',
        },
        '& fieldset': {
          transition: `all 0.4s`,
          border: '1px solid #CED1D6 !important',
        },
        '&:hover fieldset': {
          boxShadow: theme.shadows[1],
        },
        '&.Mui-focused fieldset': {
          border: '1px solid #342D3D !important',
          boxShadow: theme.shadows[1],
        },
        '& [value="Success"] + fieldset': {
          borderColor: '#12B78E !important',
        },
        '& .MuiInputAdornment-positionStart p': {
          color: theme.palette.primary.adgmBlack,
        },
      },
      [theme.breakpoints.up('sm')]: {
        '& .MuiOutlinedInput-root': {
          fontSize: '14px',
        },
      },
      [theme.breakpoints.up('md')]: {
        '& .MuiOutlinedInput-root': {
          fontSize: '16px',
        },
      },
    },
    labelLine: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    fieldTextArea: {
      width: '100%',
      padding: '18px 14px',
      border: '1px solid #CED1D6',
      borderRadius: '0px',
      minHeight: '120px',
      fontSize: '12px',
      outline: 'none',
      '&$arabicField': {
        textAlign: 'right',
        fontFamily: '"madani", sans-serif',
        lineHeight: '19.2px',
      },
      '&$phoneField': {
        textAlign: 'right',
        fontFamily: '"madani", sans-serif',
        lineHeight: '19.2px',
      },
      '&:hover': {
        transition: `all 0.4s`,
        boxShadow: theme.shadows[1],
      },
      '&:focus': {
        transition: `all 0.4s`,
        border: '1px solid #342D3D',
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '14px',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '16px',
      },
      '&::placeholder': {
        color: theme.palette.primary.dim,
      },
    },
    errorField: {
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          border: '1px solid #EA4633 !important',
        },
        '&.Mui-focused fieldset': {
          border: '1px solid #EA4633 !important',
        },
      },
    },
    errorFieldTextArea: {
      border: '1px solid #EA4633 !important',
    },
    sucessField: {
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          border: '1px solid #12B78E !important',
        },
        '&.Mui-focused fieldset': {
          border: '1px solid #EA412B78E633 !important',
        },
      },
    },
    preFilledField: {
      '& .MuiOutlinedInput-root': {
        background: theme.palette.primary.borderColor,
        color: theme.palette.primary.dim,
      },
    },
    label: {
      marginBottom: '4px',
      fontWeight: 500,
      fontSize: '12px',
      color: '#2F3239',
      [theme.breakpoints.up('sm')]: {
        fontSize: '14px',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '16px',
      },
    },
    arabicLabel: {
      textAlign: 'right',
    },
    textADGMRed: {
      color: theme.palette.primary.darkErrorRed,
    },
    errorMsg: {
      color: theme.palette.primary.errorRed,
      fontSize: '12px',
      marginLeft: '5px',
      [theme.breakpoints.up('sm')]: {
        fontSize: '14px',
      },
    },
    helperMsg: {
      display: 'block',
      color: '#6C7281',
      fontSize: '14px',
      fontWeight: 400,
      marginTop: '6px',
    },
    sucessMsg: {
      color: '#12B78E',
      fontSize: '12px',
      marginLeft: '5px',
      [theme.breakpoints.up('sm')]: {
        fontSize: '14px',
      },
    },

    disabled: {
      '& > .MuiInputBase-root': {
        background: '#EAEBEB',
        color: '#828488',
      },
    },
    arabicField: {
      '& input': {
        textAlign: 'right',
        fontFamily: '"madani", sans-serif',
        lineHeight: '19.2px',
      },
    },
    phoneField: {
      '& input': {
        direction: 'rtl !important',
        textAlign: 'left',
      },
    },

    adornmentDropDownContainer: {
      width: 'auto',
    },
    adornmentDropDown: {
      border: '0 !important',
      boxShadow: 'none !important',
      position: 'relative',
      '&:focus': {
        border: '0 !important',
        boxShadow: 'none !important',
      },

      '&::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        right: 0,
        transform: 'translateY(-50%)',
        background: theme.palette.primary.borderColor,
        width: '1px',
        height: '65%',
      },
    },
    noAdornedStartPadding: {
      '& .MuiOutlinedInput-adornedStart': {
        paddingLeft: '0',
      },
    },
    hintText: {
      marginTop: '8px',
      display: 'flex',
      justifyContent: 'space-between',
      color: theme.palette.secondary.placeHolder,
      fontSize: '14px',
    },
  };
};

export default styles;
